import { useEffect, useState } from 'react';

export default function useOnLoad() {
	const [loaded, setLoaded] = useState(typeof window === 'undefined' ? false : document.readyState === 'complete');

	useEffect(() => {
		const handleLoad = () => setLoaded(true);

		window.addEventListener('load', handleLoad);

		return () => window.removeEventListener('load', handleLoad);
	}, []);

	return loaded;
}
